<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<div class="row m-0 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">

								<div class="row">
									<div class="col-md-3 sidebar rounded">
										<div class="card pt-3 my-3">
											<div class="card-body text-center text-muted">
												<div class="row">
													<div class="col-md-12">
														<div class="card-img-best-parent text-center center-block img-thumbnail" style="max-height: 200px;">
															<img class="card-img-best" :src="user_photos[0].image" alt="画像">
														</div>
													</div>
												</div>
												<div class="row mt-2">
													<div class="col-md-12 text-center">
														<h6 class="d-inline-block">
															<strong v-if="user['legal_person']==1">販売者： {{ user['corp_name'] }}</strong>
															<strong v-if="user['legal_person']==0">販売者： {{ user['store_name'] }}</strong>
														</h6>
														<span class="d-inline-block">
															{{ user['region'] + user['address_1'] }}
														<span>
													</div>
												</div>
												<div class="row my-3">
													<div class="col-md-12">
														<span class="d-inline-block">
															代表: {{ user['last_name'] + ' ' + user['first_name'] }}
														</span>
						                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="user['evaluation']"></star-rating>
													</div>
												</div>
												<div class="col-md-12 pr-3 pl-3">
													<div class="row">
														<div class="col-md-8 px-0">
														<span class="h6" style="font-size: 0.9rem;">現在販売中のピアノ台数</span>
														</div>
														<div class="col-md-4 px-0 pr-2 d-flex align-items-center text-right" style="font-size: 0.9rem;">
														<span class="" style="display: inline-block;width: 100%;font-size: 0.9rem;"> {{ user['now_sell_num'] }}</span>台
														</div>
													</div>
												</div>
												<div class="col-md-12 pr-3 pl-3">
													<div class="row">
														<div class="col-md-8 px-0">
														<span class="h6" style="font-size: 0.9rem;">過去に販売済みのピアノ台数</span>
														</div>
														<div class="col-md-4 px-0 pr-2 d-flex align-items-center text-right" style="font-size: 0.9rem;">
														<span class="" style="display: inline-block;width: 100%;font-size: 0.9rem;"> {{ user['sell_num'] }}</span>台
														</div>
													</div>
												</div>
												<div class="row text-center mt-3">
													<div class="col-md-12">
														<a href="javascript:void(0);" @click="jumpProduct()" style="font-size: 1rem;width: 100%;" class="m-0 p-3 btn btn-success">
															<span class="font-weight-bold">販売中の中古ピアノ一覧を見る</span>
														</a>
													</div>
												</div>
												<div class="row text-center mt-2">
													<div class="col-md-12">
														<a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;border: solid 1px #9e9e9e;" class="font-weight-bold m-0 p-3 btn" @click="jumpMessageDetail(0)">問い合わせをする</a>
													</div>
												</div>

												<div class="row text-center mt-4">
													<div class="col-md-12">
														<a href="javascript:void(0);" @click="updFavorite()" style="border: solid 1px #a7a3a3;border-style: dashed;color: #575757;font-size: 1rem;width: 100%;background-color: #ffaef8!important;border-radius: 8px;" class="font-weight-bold m-0 p-3 btn btn-warning">
															<span class="heart" v-if="favorite">♥</span>
															<span class="heart" v-else>♡</span>
															お気に入り
														</a>
														<a href="javascript:void(0);" style="border: solid 1px #6a6a6a;color: #575757;font-size: 0.8rem;width: 100%;" class="m-0 mt-1 pl-1 pr-1 py-1 btn">
															<strong class="heart_count">{{ favoriteCount }}</strong>
															人がお気に入りに<br>登録しています
														</a>
													</div>
												</div>

											</div>
										</div>
									</div>
									<div class="col-sm-9 main">
										<div class="card my-3">
											<div class="card-body p-2">

												<div class="row p-0 m-0">
													<div class="col-sm-12 p-0">
														<div class="card p-1 py-3 m-1 mt-3" style="">
															<div class="main-img" style="padding: 10px;display: flex;align-items: center;">
																<img :src="mainImage2">
															</div>
															<template v-if="user_photos.length > 1">
																<hooper :itemsToShow="1.5" style="height: 100px">
																	<slide v-for="n of user_photos.length" :key="n">
																		<img :src="user_photos[(n-1)].image" @click="mainChange2((n-1))">
																	</slide>
																</hooper>
															</template>
														</div>
													</div>
												</div>
												<div class="m-3" id="counseling_ancer">
													<h6 class="font-weight-bold p-0 m-0">{{ user['slogan'] }}</h5>
													<div class="card-body text-muted p-2">
														<span>{{ user['Introduction'] }}</span>
													</div>
												</div>
												<div class="m-3" id="counseling_ancer">
													<h6 class="font-weight-bold p-0 m-0">購入された方への約束</h5>
													<div class="card-body text-muted p-2">
														<span>{{ user['promiss'] }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-3">
									</div>
									<div class="col-sm-9 main">
										<div class="card my-3">
											<div class="card-body p-2">

												<div class="tab_box">

													<div class="row p-0 tab_menu m-0" id="product_ancer">
														<div v-bind:class="{'active': isActive === 'A'}" class="org_tab col-4 p-2" v-on:click="tab_change('A')">
															<span style="font-size: 0.8rem;">ピアノ(商品)一覧</span>
														</div>
														<div v-bind:class="{'active': isActive === 'B'}" class="org_tab col-4 p-2" v-on:click="tab_change('B')">
															<span style="font-size: 0.8rem;">スタッフ一覧</span>
														</div>
														<div v-bind:class="{'active': isActive === 'C'}" class="org_tab col-4 p-2" v-on:click="tab_change('C')">
															<span style="font-size: 0.8rem;">レビュー {{ allGetSellerReviews.length }}件</span>
														</div>
													</div>

													<div class="row tab_contents">
														<div class="col-md-12">
															<div class="" v-show="isActive === 'A'">

																<div class="card col-md-12 pl-0 pr-0 m-0 my-3" v-for="n of product.length" :key="n">
																	<div class="card-body row p-2 m-0">
											                            <div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="product[(n-1)]['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<h5 class="font-weight-bold p-0 m-0 mb-3">{{ product[(n-1)]['title'] }}</h5>
																				<p class="card-text mb-3">
																					<span class="">{{ product[(n-1)]['strong_point'] }}</span>
																				</p>
												                                <p class="card-text mb-3" style="color: red;">価格(税抜):　{{ String(product[(n-1)]['price']).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}円</p>
																				<p class="card-text m-0 d-flex">販売者:　
																					<span class="mr-2" v-if="user['legal_person']==1">{{ user['corp_name'] }}</span>
																					<span class="mr-2" v-if="user['legal_person']==0">{{ user['store_name'] }}</span>
													                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="user['evaluation']"></star-rating>
																				</p>
																				<p class="card-text m-0">掲載日:　{{ date_only_format(product[(n-1)]['opened_at']) }}</p><!-- YYYY年MM月DD日 -->
																				<p class="card-text m-0">ブランド:　{{ get_hash_value(brand, product[(n-1)]['brand']) }}</p>
																				<p class="card-text m-0">型番:　{{ cinit(product[(n-1)]['model_number'], "-") }}</p>
																				<p class="card-text m-0">製造番号:　{{ cinit(product[(n-1)]['make_number'], "-") }}</p>
																				<p class="card-text m-0">外装:　{{ get_hash_value(color, product[(n-1)]['color']) }}／{{ cinit(product[(n-1)]['exterior_finish'], "-") }}</p>
																				<button @click="jumpDetail(product[(n-1)]['id'])" style="position: absolute;bottom: 20px;right: 20px;" class="btn btn-primary">詳細</button>
																			</div>
																		</div>
																	</div>
																</div>

															</div>
															<div class="" v-show="isActive === 'B'">

																<div class="card col-md-12 pl-0 pr-0 m-0 my-3" v-for="n of staffs.length" :key="n">
																	<div class="card-body row p-2">
															
																		<div class="col-md-3">
																			<div class="card-img-best-parent text-center center-block img-thumbnail" style="max-height: 175px;">
																				<img class="card-img-best" :src="staffs[(n-1)]['image']" alt="画像">
																			</div>
																		</div>
																		<div class="col-md-9">
																			<div class="card-text pb-1">
																				<div class="row">
																					<div class="col-md-6">
																						<span class="pull-left pt-0 mr-3"><strong style="font-size: 1rem;">{{ staffs[(n-1)]['last_name'] }} {{ staffs[(n-1)]['first_name'] }}</strong></span>
																					</div>
																				</div>
																			</div>
																			<hr class="my-1">
																			<p class="card-text">
																				{{ staffs[(n-1)]['slogan'] }}
																			</p>
																			<p class="card-text">
																				{{ staffs[(n-1)]['profile'] }}
																			</p>
																		</div>
																	</div>
																</div>

															</div>
															<div class="" v-show="isActive === 'C'">

																<div v-for="(review, index) in allGetSellerReviews">
																	<div class="card col-md-12 pl-0 pr-0 m-0 my-3">
																		<div class="card-header p-2 m-0">
																			<div class="row px-3">
																				<div class="col-2 pl-1 pr-1 m-0 d-flex justify-content-center">
																					<img class="" :src="review['image1']" style="width: auto;max-height: 60px;">
																				</div>
																				<div class="col-10 pl-2 pr-0 m-0 text-left my-auto">
																					<p class="mb-2" style="font-size: 0.9rem;">ブランド：{{ get_hash_value(brand, review['brand']) }}</p>
																					<p class="mb-2" style="font-size: 0.9rem;">モデル名：{{ review['model_number'] }}</p>
																				</div>
																			</div>
																		</div>
																		<div class="card-body row p-2 m-0">
																			<div class="col-md-3 p-2 m-0" style="flex-flow: column;display: flex;align-items: center;justify-content: center;">
																				<img class="" :src="user_photo_change(null)" style="width: 80%;height: auto;">
																				<p>{{ review['old'] }}歳 {{ get_hash_value(gender, review['gender']) }}購入者</p>
																				<p>{{ review['nickname'] }}さん</p>
																			</div>
																			<div class="card col-md-9 pl-0 pr-0 m-0" style="position: relative;">
																				<div class="card-body">
																					<div class="row mb-4">
																						<div class="col-md-8 text-left d-flex">
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="review['evaluation']"></star-rating>
																						</div>
																						<span class="col-md-4 text-right">
																							{{ date_only_format(review['created_at']) }}
																						</span>
																					</div>
																					<p class="card-text mb-4">
																						商品の満足度：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['product_evaluation'] }}</span>　
																						掲載情報の正確性：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['infomation_evaluation'] }}</span>　
																						スタッフの対応：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['staff_evaluation'] }}</span>　
																						決済方法：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['payment_evaluation'] }}</span>　
																						梱包：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['packing_evaluation'] }}</span>　
																						配送：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['delivery_evaluation'] }}</span>
																					</p>
																					<p class="card-text mb-4" style="">
																						<span class="">{{ review['contents'] }}</span>
																					</p>
																					<template v-if="review['review_comment_contents']!=''">
																						<p style="font-weight: bold;">
																							<span v-if="user['legal_person']==1">{{ user['corp_name'] }}</span>
																							<span v-if="user['legal_person']==0">{{ user['store_name'] }}</span>
																							の返答
																						</p>
																						<p class="card-text mt-2 mb-4" style="">
																							<span class="">{{ review['review_comment_contents'] }}</span>
																						</p>
																					</template>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>

															</div>
														</div>
													</div>

												</div>

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Hooper, Slide } from 'hooper';
import StarRating from 'vue-star-rating'

export default {
	name: 'SellerDetail',
    components: {
      Hooper,
      Slide,
	  'star-rating': StarRating,
    },
	data () {
		const gender = [
			{"no":"1","name":"男性"},
			{"no":"2","name":"女性"},
		];
		const state = [
			{"no":"1","name":"新古品"},
			{"no":"2","name":"中古品（非常に良い）"},
			{"no":"3","name":"中古品（良い）"},
			{"no":"4","name":"中古品（あまり良くない）"},
			{"no":"5","name":"中古品（悪い）"},
		];
		const type = [
			{"no":"1","name":"グランドピアノ（GP）"},
			{"no":"2","name":"アップライトピアノ（UP）"},
	    ];
		const brand = [
			{"no":"1","name":"ヤマハ（YAMAHA）"},
			{"no":"2","name":"カワイ（KAWAI）"},
			{"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
			{"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
			{"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
			{"no":"6","name":"ボストン　（BOSTON）"},
			{"no":"7","name":"ディアパソン　（DIAPASON）"},
			{"no":"8","name":"アポロ　（APOLLO）"},
			{"no":"9","name":"国産ピアノ"},
			{"no":"10","name":"輸入ピアノ"},
	    ];
		const color = [
			{"no":"1","name":"黒"},
			{"no":"2","name":"木目"},
			{"no":"3","name":"白"},
			{"no":"4","name":"その他"},
	    ];
		return {
			gender,
			state,
			type,
			brand,
			color,

			users_id: null,
			product: null,
			user: null,
			user_photos: null,
			staffs: null,
			reviews: null,

			// お気に入り
			favoriteCount: 0,
			favorite: false,

			seller_review: [],

			now_sell_product_count: 0,
			back_sell_product_count: 0,

			reviewCount: 0,
			isActive: 'A',

			main_image2: null,

		}
	},
	methods: {
	  jumpProduct: function(){
		this.$nextTick(function() {
		  document.getElementById("product_ancer").scrollIntoView(true)
		});
	  },

	  updFavorite() {
	    if ( this.login_check(this.token) ) {
		  this.upd_favorite();
		}
		return false;
	  },
      // お気に入り更新処理
      async upd_favorite() {
        this.$store.dispatch('product/upd_favorite', {
          type: 2,
          sellers_id: this.user.id,
        //   users_id: this.,
        }).then(res => {
          console.log(res);
		  this.favorite = !this.favorite;
		  if(this.favorite){
			this.favoriteCount++;
		  }else {
			this.favoriteCount--;
		  }
          return false;
        }, error => {
          // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
          console.log(error.response.data);
          if ('error' in error.response.data) {
            alert(error.response.data['error']);
            window.scrollTo({
              top: 0,
            });
          }
        });
        return false;
      },
	  // this.$route.params.users_id
	  async get_seller_detail(id) {
		this.$store.dispatch('user/get_seller_detail', {
          id: id,
        }).then(res => {
		  console.log(res);
		  let ret = res.data.user;
		  this.product = ret['product'];
		  this.user = ret['user'];
		  this.user_photos = ret['user_photos'];
		  if ( this.user_photos.length > 0 ) {
		    this.main_image2 = this.user_photos[0].image;
		  }
		  this.favorite = ret['favorite'];
		  this.favoriteCount = ret['favorite_count'];
		  this.staffs = ret['staffs'];
		  this.seller_review = ret['seller_review'];
		//   this.reviews = ret['reviews'];
		  console.log(this.product);
		  console.log(this.user);
		  console.log(this.user_photos);
		  console.log(this.favorite);
		  console.log(this.favoriteCount);
		  console.log(this.staffs);
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },

	  mainChange2(key) {
		this.main_image2 = this.user_photos[key].image;
	  },

      tab_change: function(num){
        this.isActive = num
      },

	  jumpDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },

	  jumpMessageDetail: function(status){
        this.$router.push({path: '/message/'+String(this.user.id)+'/'+String(status)+'/0'});
	  },

	},
	created() {
		this.users_id = this.$route.params.users_id;
		this.get_seller_detail(this.users_id);
	},
	computed: {
		...mapState('auth', ['token']),
		token: function() {
			return this.$store.getters["auth/token"];
		},
    // isMypage() {
    //   return location.pathname.indexOf("mypage")!=-1;
    // }
		allGetSellerReviews: function() {
			return this.seller_review;
		},

		mainImage2: function() {
			return this.main_image2;
		},

	},
}
</script>

<style scoped>
.hooper-slide {
	width: 150px!important;
    display: flex!important;
    align-items: center!important;
	padding: 10px!important;
    border: solid 1px #c9c9c9!important;
    margin: 0px 2px!important;
    border-radius: 6px!important;
	overflow: hidden!important;
}
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SellerDetail.vue